// extracted by mini-css-extract-plugin
export default {"MarkdownViewerContainer":"MarkdownViewer-module__MarkdownViewerContainer__T9V3jI2"};